import { ClickOutsideEvent } from '../useClickOutside/useClickOutside.ts';

export default function isScrollbarClick(evt: ClickOutsideEvent): boolean {
  // Consider clicking the scrollbar as being 20px from the edge of the screen
  // For touch events, use the first touch point
  let clientX: number, clientY: number;

  if ('touches' in evt && evt.touches.length > 0) {
    // TouchEvent
    clientX = evt.touches[0].clientX;
    clientY = evt.touches[0].clientY;
  } else if ('clientX' in evt) {
    // MouseEvent or PointerEvent
    clientX = evt.clientX;
    clientY = evt.clientY;
  } else {
    return false;
  }

  return (
    Math.abs(clientX - document.documentElement.clientWidth) < 20 ||
    Math.abs(clientY - document.documentElement.clientHeight) < 20
  );
}
